import { JUNE_2025_NEW_CUSTOMER_STARTER_PROMOTION_KEYS } from 'pricing-pages-ui-components/constants/PromotionKeys';
import Products from 'merchandise-lib/constants/Product';
import { isAvailableCurrencyCode } from '../../utils/typeguards';
import { useDisplayedCurrencyCode } from '../pricing/useCurrencyDetails';
import { usePerMonthPricesForRecurringTerms, useProductPromotionIds } from '../pricing/useGrowthPurchaseOptions';
const STARTER_PRODUCT_API_NAME = Products.MARKETING_HUB_STARTER;

// Pages where the banner should be displayed
const INCLUDED_PAGES = ['SUITE', 'MARKETING', 'SALES', 'SERVICE', 'DATA', 'CMS', 'CONTENT', 'FREE'];
export const useStarterPromo2025Banner = ({
  screen,
  tab
}) => {
  const {
    annualPrice,
    monthlyPrice,
    loading,
    error
  } = usePerMonthPricesForRecurringTerms({
    productApiName: STARTER_PRODUCT_API_NAME,
    quantity: 1
  });
  const {
    promotionIds,
    loading: promotionIdsLoading
  } = useProductPromotionIds({
    productApiName: STARTER_PRODUCT_API_NAME
  });
  const displayedCurrencyCode = useDisplayedCurrencyCode();
  // Only proceed if we have a supported currency
  const supportedCurrencyCode = displayedCurrencyCode && isAvailableCurrencyCode(displayedCurrencyCode) ? displayedCurrencyCode : null;

  // Check if eligible for promotion using the properly extracted promotion IDs
  const eligibleForPromotion = promotionIds.some(promotionId => JUNE_2025_NEW_CUSTOMER_STARTER_PROMOTION_KEYS.includes(promotionId));
  const isValidScreenForPromo = INCLUDED_PAGES.includes(screen) && (!tab || tab !== 'ENTERPRISE');
  const shouldShowBanner = Boolean(!loading && !promotionIdsLoading && !error && eligibleForPromotion && annualPrice && monthlyPrice && displayedCurrencyCode && isValidScreenForPromo);
  return {
    shouldShowBanner,
    error,
    annualPrice,
    monthlyPrice,
    currencyCode: supportedCurrencyCode,
    loading: loading || promotionIdsLoading
  };
};